import { b as ToastContext } from '../../useOrchard-45cfc194.js';
export { c as Toast, T as ToastProvider } from '../../useOrchard-45cfc194.js';
import * as React from 'react';
import '../../tslib.es6-18cb2814.js';
import 'react-dom';
import '../../index-8887fc24.js';
import 'react-spring';
import '../../countries-34fea817.js';
import './IconButton.js';
import '../../skeleton.module-7c98b8f8.js';
import './TextLink.js';
import './Typography.js';
import '../../ResizeObserver-d78e3707.js';
import '../../CircleAlertIcon-a6cd83ad.js';
import '../../CloseIcon-25692563.js';
import '../../InfoIcon-22134611.js';
import '../../ThemeProvider-e3ab770b.js';

function useToast() {
    var context = React.useContext(ToastContext);
    if (!context) {
        throw new Error("useToast must be a child of ToastProvider");
    }
    return context;
}

export { useToast };
